import {jQuery} from "./boot";
import {Messages} from './messages/Messages'
import {AppConfig} from "./AppConfig";
import {ContainerTypeNamer} from "./dto/com.rico.sb2.support";
import {CloneProcess} from "./modals/CloneProcess";

const messages = new Messages();
const containerTypeNamer = new ContainerTypeNamer();

interface ProcessListPageParams {
	canEdit?: boolean
}

const ToggleSubprocessButton = {
	get() {
		return document.querySelector<HTMLButtonElement>('button[name="btnToggleSubprocess"]')!!
	},

	get active() {
		return ToggleSubprocessButton.get().classList.contains('active');
	},

	toggle() {
		const button = ToggleSubprocessButton.get();
		if (button?.classList.contains('active')) {
			button?.classList.remove('active');
		} else {
			button?.classList.add('active');
		}
	}
};

(window as any).ProcessListTableButtons = () => ({
	btnToggleSubprocess: {
		text: 'Показывать подпроцессы',
		icon: 'bi-diagram-2',
		html: `<button class="btn btn-secondary me-3" name="btnToggleSubprocess"><i class="bi-diagram-2"></i><span>Показывать подпроцессы</span></button>`,
		event() {
			ToggleSubprocessButton.toggle()

			const table = jQuery('#table')
			table.bootstrapTable('refresh', {
				url: ToggleSubprocessButton.active
					? `${AppConfig.CP}/processes/listSubprocesses`
					: `${AppConfig.CP}/processes/listPage`
			});
		}
	}
});

export class ProcessListPage {
	private readonly canEdit: boolean;

	constructor({canEdit}: ProcessListPageParams) {
		this.canEdit = !!canEdit
	}

	start() {
		const canEdit = this.canEdit;

		jQuery('#table').bootstrapTable({
			url: `${AppConfig.CP}/processes/listPage`,
			sidePagination: 'server',

			responseHandler(res) {
				return {total: res.totalElements, rows: res.content}
			},
			rowStyle(row) {
				if (row.deleted) {
					return {classes: 'text-decoration-line-through'};
				}
				return {}
			},
			columns: [
				{},
				{},
				{
					formatter(value: any, row: any) {
						return containerTypeNamer.name(row.containerType);
					}
				},
				{
					class: 'text-nowrap text-center'
				},
				{
					class: 'text-nowrap text-center',
					formatter(value: any, row: any) {
						if (row.subprocess) {
							return `<span title="Количество использованных позиций">${row.actionCount}</span>`
						}
						return `<span title="Количество использованных подпроцессов">${row.subprocessCount}</span> / <span title="Количество использованных позиций">${row.actionCount}</span>`
					}
				},
				{
					class: 'text-end',
					formatter(value: any, row: any) {
						const text = row.aoSpeedHorizontal == null ? '' : `${row.aoSpeedHorizontal}%`
						return `<span>${text}</span>`
					}
				},
				{
					class: 'text-nowrap text-end',
					formatter(value: any, row: any) {
						if (row.deleted) return '';

						if (canEdit) {
							return `
                                <a href="${AppConfig.CP}/processes/${row.id}/delete" class="btn btn-danger btn-sm">${messages.get("button.delete")}</a>
                                <button class="btn btn-secondary btn-sm" onclick="controller.cloneProcess(${row.id})">${messages.get("button.clone")}</button>
                                <a href="${AppConfig.CP}/processes/${row.id}/edit" class="btn btn-secondary btn-sm">${messages.get("button.edit")}</a>`
						}

						return `
                                <a href="${AppConfig.CP}/processes/${row.id}" class="btn btn-secondary btn-sm">${messages.get("button.view")}</a>`
					}
				}
			]
		})
	}

	cloneProcess(id: number) {
		new CloneProcess(id).showModal((next: number) => document.location = `${AppConfig.CP}/processes/${next}/edit`);
	}
}